"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// NOTE: It clones incomplete arrays incorrectly
var _default = exports["default"] = function _default(object) {
  return JSON.parse(JSON.stringify(object));
};